import { Injectable } from '@angular/core';
import { GrupoParada } from '@tivic-team/manager-ts/dist/mob/entities/parada/grupo-parada.entity';
import { GrupoParadaController } from 'app/controllers/mob/grupo-parada.controller';
import { GrupoParadaDTO } from '../../model/dtos/mob/grupoParada.dto';
import { LoaderService } from '../loader.service';
import { GrupoParadaSearch } from './grupo-parada.search';


@Injectable()
export class GrupoParadaService{

    constructor(
        private _grupoParadaController: GrupoParadaController,
        private _loaderService: LoaderService
    ){}

    async getAllPracaTaxi():Promise<GrupoParada[]>{
        this._loaderService.show();
        return this._grupoParadaController.getAllPracaTaxi().finally(() => this._loaderService.hide());
    }

    async findPontostaxi(grupoParadaSerach: GrupoParadaSearch):Promise<Array<GrupoParada>>{
        this._loaderService.show();
        try {
            return await this._grupoParadaController.findPontostaxi(grupoParadaSerach && grupoParadaSerach.getFilters() || null).finally(() => this._loaderService.hide());
        }
        catch (error) { 
            return null; 
        }
    }

    async find(grupoParadaSerach: GrupoParadaSearch):Promise<Array<GrupoParadaDTO>>{
        this._loaderService.show();
        try {
            return await this._grupoParadaController.find(grupoParadaSerach && grupoParadaSerach.getFilters() || null).finally(() => this._loaderService.hide());
        }
        catch (error) { 
            return null; 
        }
    }
    
    async get(cdGrupoParada: number): Promise<GrupoParadaDTO> {
        this._loaderService.show();
        return this._grupoParadaController.get(cdGrupoParada).finally(() => this._loaderService.hide());
    }

    async getPontostaxi(cdGrupoParada: number): Promise<GrupoParadaDTO> {
        this._loaderService.show();
        return this._grupoParadaController.get(cdGrupoParada).finally(() => this._loaderService.hide());
    }
}